<template>
    <div id="primaryNoticeDetail">
        <div class="second-header-wrap">
            <el-button @click="$router.back()" size="medium">返回</el-button>
            <template v-if="checkIndexPermission(permission, '/staterunEnrolSystem/enrolNoticeManage')">
                <el-button type="primary" @click.native="jumpToPage('noticeEdit', {id})" size="medium">编辑</el-button>
                <el-button type="primary" v-if="state === 1" @click.native="publishHandler" size="medium">发布</el-button>
                <el-button type="primary" v-if="state === 2" @click.native="changeBulu" size="medium">
                    <template v-if="isOpenAdd == 0">开启</template><template v-else>关闭</template>补录
                </el-button>
            </template>
        </div>
        <div class="main-container">
            <h1>{{title}}</h1>
            <div class="main-container__sub">
                <div class="create-user">{{createUserName}}&nbsp;&nbsp;{{createTime | timeSuffixFilter}}</div>
                <div class="signup-info">招生登记日期：{{startTime | timeFilter}}——{{endTime | timeFilter}}</div>
                <div class="signup-info">出生日期范围：{{beginYear}}——{{endYear}}</div>
                <image-previewer tag="richtext" >
                    <div class="content" v-html="content"></div>
                </image-previewer>
            </div>
        </div>
        <div class="url-info">
            <div class="qrcode-container">
                <div>
                    pc端招生登记链接：{{pcUrl}}
                </div>
                <div>
                    移动端招生登记链接：{{mobileUrl}}
                </div>

                <img :src="qrcodeUrl" />
                <div class="qrcode-date">报名 {{startTime | dateFilter}} 至 {{endTime | monthFilter}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import QRCode from 'qrcode'
    import ImagePreviewer from '@/components/ImagePreviewer/ImagePreviewer';

    import {
        getNotice,
        editOrPublishSchoolEnrolNotice,
        openOrCloseStateRunAdd
    } from '@/api/primary/notice';
    import baseMixin from '@/mixins/baseMixin';

    export default {
        name: "NoticeDetail",
        data() {
            return {
                id: this.$route.query.id,
                title: '',
                content: '',
                startTime: '',
                endTime: '',
                voteId: '',
                createUserName: '',
                createTime: '',
                state: 1,
                logoURL: '',
                templateName: '',
                yearNum: '',
                publishType: null,
                enrolType: null,
                beginYear: '',
                endYear: '',
                publishTo: '',
                qrcodeUrl: '',
                pcUrl: '',
                mobileUrl: '',
                schoolId: '',
                isOpenAdd: 0,
            }
        },
        components: {ImagePreviewer},
        mixins: [baseMixin],
        computed: {
            ...mapGetters(['permission'])
        },
        filters: {
            timeFilter(value) {
                return value.substring(0, value.lastIndexOf(':'));
            },
            dateFilter(value) {
                return value.substring(0, value.lastIndexOf(' '));
            },
            monthFilter(value) {
                return value.substring(value.indexOf('-') + 1, value.lastIndexOf(' '));
            }
        },
        created() {
            getNotice({
                noticeId: this.id
            })
                .then(res => res.data)
                .then(data => {
                    if(data.result) {
                        const pageData = data.data;
                        this.title = pageData.title;
                        this.content = pageData.content;
                        this.startTime = pageData.startTime;
                        this.endTime = pageData.endTime;
                        this.beginYear = pageData.beginYear;
                        this.endYear = pageData.endYear;
                        this.enrolType = pageData.enrolType;
                        this.publishType = pageData.publishType;
                        this.createUserName = pageData.createUserName;
                        this.publishTo = pageData.publishTo;
                        this.createTime = pageData.createTime;
                        this.yearNum = pageData.yearNum;
                        this.state = pageData.state;
                        this.logoURL = pageData.logoURL;
                        this.schoolId = pageData.schoolId;
                        this.isOpenAdd = pageData.isOpenAdd;

                        const baseHref = window.location.href.indexOf('www.weixiaojia.net') !== -1 || window.location.href.indexOf('localhost') !== -1 ? 'https://www.weixiaojia.net/mobile/#/' : 'https://m.www.weixiaojia.cn/mobile/#/';

                        QRCode.toDataURL(`${baseHref}primarySchoolSignup/notice?id=${this.id}&schoolId=${pageData.schoolId}`)
                            .then(url => {
                                this.qrcodeUrl = url;
                            })
                            .catch(() => {
                            });

                        this.mobileUrl = `${baseHref}primarySchoolSignup/notice?id=${this.id}&schoolId=${pageData.schoolId}`;
                        this.pcUrl = window.location.href.indexOf('www.weixiaojia.net') !== -1 || window.location.href.indexOf('localhost') !== -1 ? `https://www.weixiaojia.net/schoolSignup/#/primary/outer/outerNotice?id=${this.id}&schoolId=${pageData.schoolId}` : `https://www.zhxiaoyuan.cn/schoolSignup/#/primary/outer/outerNotice?id=${this.id}&schoolId=${pageData.schoolId}`;
                    }
                })
        },
        methods: {
            publishHandler() {
                const args = {};

                args.id = this.id;
                args.yearNum = this.yearNum;
                args.logoURL = this.logoURL;
                args.content = this.content;
                args.state = 2;
                args.title = this.title;
                args.publishTo = this.publishTo;
                args.startTime = this.startTime;
                args.endTime = this.endTime;
                args.beginYear = this.beginYear;
                args.endYear = this.endYear;
                args.enrolType = this.enrolType;
                args.publishType = this.publishType;

                this.$confirm('是否确认发布?', '发布', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    editOrPublishSchoolEnrolNotice(args)
                        .then(res => res.data)
                        .then(data => {
                            if(data.result) {
                                const _this = this;
                                this.$message({
                                    message: '发布公告成功',
                                    type: 'success',
                                    onClose: function () {
                                        _this.$router.back();
                                    }
                                });
                            }
                        });
                }).catch(() => {
                });
            },
            changeBulu() {
                openOrCloseStateRunAdd({
                    noticeId: this.id,
                    openState: this.isOpenAdd == 0 ? 1 : 0,
                })
                    .then(res => res.data)
                    .then(data => {
                        if(data.result) {
                            this.$message({
                                message: `${this.isOpenAdd == 0 ? '开启' : '关闭'}成功`,
                                type: 'success'
                            });
                            this.isOpenAdd = this.isOpenAdd == 0 ? 1 : 0;
                        }
                    })
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../styles/mixin.scss";
    .url-info {
        width: 92%;
        min-width: 1200px;
        padding: 5px 4%;
        .qrcode-container{
            width:70%;
            margin:10px auto;
            text-align: center;
            div{
                text-align:left;
                margin-bottom:10px;
            }
            .qrcode-date {
                text-align: center;
            }
        }
    }
        

    .table-container {
        width: 92%;
        min-width: 1200px;
        padding: 5px 4%;
    }
    .second-header-wrap {
        left: 0;
        width: 92%;
        min-width: 1200px;
        height: 60px;
        line-height: 60px;
        padding: 5px 4%;
        background-color: #fff;
        z-index: 1000;
    }
    .main-container {
        width: 810px;
        margin: 10px auto;
        .main-container__sub {
            width: 70%;
            margin: 0 auto;
        }
        h1 {
            text-align: center;
        }
        .content {
            width: 100%;
            margin: 0 auto;
            @include richtext;
        }
        .create-user {
            float: right;
            margin-bottom:20px;
        }
        .signup-info, .signup-template {
            clear: both;
            text-align: center;
            margin-bottom:10px;
        }
        .signup-template {
            margin-bottom: 10px;
        }

    }

</style>
<style lang="scss">
    @import "../../../styles/mixin.scss";
    #primaryNoticeDetail {
        .content {
            @include richtext;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/primary/notice/NoticeDetail.vue